import { Injectable } from '@angular/core';
import { CheckinBaseClass } from '../../components';
import {
  GetStandbyTravelersResultState,
  resetGetStandbyTravelersResult,
  selectGetStandbyTravelersResultIsFailureStatus,
  selectGetStandbyTravelersResponse,
  selectGetStandbyTravelersResultState,
  setGetStandbyTravelersResultFromApi,
} from '@common/store/get-standby-travelers-result';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import {
  DefaultService as Api,
  PostTravelersStandByTravelersRequest,
  PostTravelersStandByTravelersResponse,
} from 'src/sdk_checkin';
@Injectable()
export class GetStandbyTravelersResultStoreService extends CheckinBaseClass {
  private _result$: Observable<GetStandbyTravelersResultState>;
  private _result!: GetStandbyTravelersResultState;
  get result() {
    return this._result;
  }

  constructor(private _store: Store<GetStandbyTravelersResultState>, private api: Api) {
    super();
    this._result$ = this._store.pipe(
      select(selectGetStandbyTravelersResultState),
      filter((data) => !!data)
    );
    this.subscribeService(this._result$, (data) => {
      this._result = data;
    });
  }

  override destroy(): void {}

  /**
   * GetStandbyTravelersResultStateStore のObservableを返却する
   * @returns GetStandbyTravelersResultStateStore の全ての値を取得するObservable
   */
  public getResultState$() {
    return this._result$.pipe(filter((state) => !!state.model));
  }

  /**
   * API呼び出しが失敗したかのObservableを返却する
   * @returns isFailureの値を取得するObservable
   */
  public getIsFailure$() {
    return this._store.pipe(
      select(selectGetStandbyTravelersResultIsFailureStatus),
      filter((state) => !!state)
    );
  }

  /**
   * チェックイン空港空席待ち人数検索が正常終了したら結果を取得するObservable
   */
  public getResultStateIfSuccessful$() {
    return this._result$.pipe(filter((state) => !state.isFailure && !state.isPending && !!state.model));
  }

  /**
   * API呼び出し結果のObservableを受け取りStoreに格納する
   * @param call API呼び出し結果を取得するObservable
   */
  private setResult(call: Observable<PostTravelersStandByTravelersResponse>) {
    this._store.dispatch(setGetStandbyTravelersResultFromApi({ call }));
  }

  /**
   * チェックイン空港空席待ち人数検索のストアをクリアする
   */
  public clear() {
    this._store.dispatch(resetGetStandbyTravelersResult());
  }

  /**
   * チェックイン空港空席待ち人数検索APIの呼び出しと、呼び出し結果のStoreへの設定を行う
   */
  public callApi(condition: PostTravelersStandByTravelersRequest) {
    const call = this.api.travelersGetStandbyTravelersPost(condition);
    this.setResult(call);
  }

  /**
   * チェックイン空港空席待ち人数検索APIのResponse modelを取得
   */
  public getResponse$() {
    return this._store.pipe(
      select(selectGetStandbyTravelersResponse),
      filter((state) => !!state)
    );
  }
}
